"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoDeliveryTomorrow = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RoDeliveryTomorrow = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    delivery_date: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    prohibited_items_string: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=ro-delivery-tomorrow.js.map